export function ContactPage() {
  return (
    <article className="legal-document">
      <h1>Canais de Atendimento e Contato</h1>
      <p className="text-muted">
        LONDON SIM GESTÃO DE DOCUMENTOS LTDA (Datasci Editora) — CNPJ 22.390.588/0001-70
      </p>

      <section className="card" style={{ maxWidth: 640, marginBottom: "var(--space-6)" }}>
        <h3>Atendimento Editorial e Suporte ao Leitor</h3>
        <p>
          Para dúvidas sobre pedidos, confirmação de pagamentos Pix, downloads de ebooks e suporte à plataforma:
        </p>
        <p>
          <strong>E-mail de Suporte:</strong>{" "}
          <a href="mailto:contato@datasci.com.br">contato@datasci.com.br</a>
          <br />
          <span className="text-muted" style={{ fontSize: "var(--text-xs)" }}>
            Horário de atendimento: Segunda a Sexta-feira, das 09h às 18h (Horário de Brasília).
          </span>
        </p>
      </section>

      <section className="card" style={{ maxWidth: 640, marginBottom: "var(--space-6)" }}>
        <h3>Licenciamento Corporativo e Vendas B2B</h3>
        <p>
          Para empresas e instituições interessadas em planos corporativos de distribuição de ebooks, cotas de treinamento e
          integrações com portais institucionais:
        </p>
        <p>
          <strong>E-mail Corporativo:</strong>{" "}
          <a href="mailto:empresas@datasci.com.br">empresas@datasci.com.br</a>
        </p>
      </section>

      <section className="card" style={{ maxWidth: 640 }}>
        <h3>Privacidade de Dados e Encarregado LGPD (DPO)</h3>
        <p>
          Para exercício de direitos de titularidade de dados previstos no artigo 18 da Lei nº 13.709/2018 (acesso, correção,
          portabilidade e exclusão de dados pessoais):
        </p>
        <p>
          <strong>Canal do Encarregado:</strong>{" "}
          <a href="mailto:contato@datasci.com.br?subject=LGPD%20Privacidade">contato@datasci.com.br</a> (com assunto &ldquo;LGPD — Privacidade&rdquo;)
        </p>
      </section>
    </article>
  );
}
